import {State} from "@ispm-client/modules/process-executor/store";
import {createSelector, MemoizedSelector} from "@ngrx/store";
import {selectBpmnProcessState} from "@ispm-client/modules/process-executor/store/selectors/bpmn-process-state.selector";

const getMandatoryNodesVisited = (state: State): string[] => state.mandatoryNotesVisited;

export const selectMandatoryNodesVisited: MemoizedSelector<
  object,
  any
  > = createSelector(selectBpmnProcessState, getMandatoryNodesVisited);

